import React, { Component } from 'react';
import Main from './main';

class App extends Component {

    constructor(props) {
        super(props);
        this.state = {};
    };

    componentWillMount(){}

    render() {
        return (
            <Main />
        )
    }

}

export default App



// WEBPACK FOOTER //
// ./src/App.js